const CookieConsent = function () {
    const cookieDurationInDays = 30;
    const cookieName = "cookie-consent";

    const init = function () {
        if (isInWebview()) {
            return;
        }

        if (!getCookie(cookieName)) {
            let $cookieConsent = $('<div/>', {'class': 'cookie-consent'});
            let $cookieConsentContainer = $('<div/>', {'class': 'cookie-consent--container'});
            let $itemText = $('<div/>', {'class': 'item-text'});
            let $itemLink = $('<div/>', {'class': 'item-link'});
            let $itemButton = $('<div/>', {'class': 'item-button'});

            if (typeof lang !== 'undefined' && lang === 'en') {
                $itemText.append('<div>This website uses cookies to provide you with an optimal navigation experience. <a href="/en/cookies" aria-label="learn more about cookies" tabindex="0" rel="noopener noreferrer nofollow" target="_blank" onclick="pushDataLayerCookieConsentConditions();">Cookies</a></div>');
                $itemLink.append('<a href="/en/cookies" aria-label="learn more about cookies" rel="noopener noreferrer nofollow" target="_blank" onclick="pushDataLayerCookieConsentConditions();">Cookies</a>');
                $itemButton.append('<button>I understand</button>');
            } else {
                $itemText.append('<div>Ce site utilise des témoins (appelés « Cookies »), afin de vous fournir une expérience de navigation optimale. <a href="/temoins" aria-label="en apprendre sur les cookies" tabindex="0" rel="noopener noreferrer nofollow" target="_blank" onclick="pushDataLayerCookieConsentConditions();">Témoins</a></div>');
                $itemLink.append('<a href="/temoins" aria-label="en apprendre sur les cookies" rel="noopener noreferrer nofollow" target="_blank" onclick="pushDataLayerCookieConsentConditions();">Témoins</a>');
                $itemButton.append('<button>J\'ai compris</button>');
            }

            $cookieConsentContainer.append($itemText, $itemLink, $itemButton);
            $cookieConsent.append($cookieConsentContainer);
            $('body').append($cookieConsent);
        }
    };

    const getCookie = function (cookieName) {
        var i, x, y, ARRcookies = document.cookie.split(";");
        for (i = 0; i < ARRcookies.length; i++) {
            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
            x = x.replace(/^\s+|\s+$/g, "");
            if (x == cookieName) {
                return unescape(y);
            }
        }
    };

    const setCookie = function (cookieName, value, expirationDays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + expirationDays);
        var cookieValue = escape(value) + ((expirationDays == null) ? "" : "; expires=" + exdate.toUTCString());
        document.cookie = cookieName + "=" + cookieValue + "; path=/";
    };

    const accept = function () {
        setCookie(cookieName, true, cookieDurationInDays);
        $('.cookie-consent').fadeOut();
        pushDataLayerCookieConsentAccept();
        uPass.setBannerOffset(false);
    };

    return {
        accept: accept,
        init: init
    };
}();